export function formatMoney(n) {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (Math.abs(v) >= 1_000) return `$${(v / 1_000).toFixed(1)}k`;
  return `$${v.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function formatPct(n) {
  return `${Number(n || 0).toFixed(1)}%`;
}

export function formatInt(n) {
  return Number(n || 0).toLocaleString();
}

export function isoDaysAgo(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString();
}

export function nowIso() {
  return new Date().toISOString();
}

export function readableStatus(s) {
  if (!s) return "";
  return s.replaceAll("_", " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
